// extracted by mini-css-extract-plugin
module.exports = {"ProgressBackground":"ProgressBackground--1hvFK","ProgressBar":"ProgressBar--_xMOH","Text":"Text--3S8Zx"};